import React from 'react'
import './style.css'
import { Link } from 'react-router-dom'

export default function Games() {
  return (
    <div className='Games'>
      <span>
        {/* <h2>Free Games</h2>
          <div className='Games_Con'>
            <Link to={'/the-quiz-game'} className='Games_Item'>
              <div style={{backgroundImage:`url(https://yt3.googleusercontent.com/eJimOIb7VP_yWslvbHGj_seTOXbc_Fj793YNFFxYC_IIF5FK77LbuqU80RSQyhRHxtFszkQKCg=s900-c-k-c0x00ffffff-no-rj)`}} className='Games_Img'/>
            </Link>
          </div> */}
      </span>
    </div>
  )
}
